import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Injector,
} from '@angular/core';
import { CurrencyPipe, DatePipe } from '@angular/common';
import { IsFinalTagComponent } from '../is-final-tag/is-final-tag.component';
import { MatDialog } from '@angular/material/dialog';
import { JournalPacketAddEditComponent } from '../journal-packet-add-edit/journal-packet-add-edit.component';
import { EjournalService } from '../../services/ejournal.service';
import { NotificationService } from '@et/notifications';
import { PresentationalAtomsModule } from '@et/presentational/atoms';

@Component({
  selector: 'et-journal-packet-card',
  imports: [
    CurrencyPipe,
    DatePipe,
    IsFinalTagComponent,
    PresentationalAtomsModule,
  ],
  templateUrl: './journal-packet-card.component.html',
  styleUrl: './journal-packet-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JournalPacketCardComponent {
  private readonly dialog = inject(MatDialog);
  private readonly ejournalService = inject(EjournalService);
  private readonly injector = inject(Injector);
  private readonly notificationService = inject(NotificationService);

  eJournal = this.ejournalService.eJournal;
  eJournalLoading = this.ejournalService.eJournalLoading;

  /**
   * Opens the journal packet add/edit dialog.
   */
  onCreateEJournal() {
    const packet = this.ejournalService.selectedPacket();
    const profile = this.ejournalService.profile();

    if (!packet || !profile) {
      this.notificationService.showError(
        'Please select a packet and profile to create an eJournal.',
      );
      return;
    }

    this.dialog.open(JournalPacketAddEditComponent, {
      injector: this.injector,
      panelClass: ['et-dialog-radius', 'et-dialog-padding'],
      autoFocus: false,
      width: '100%',
      maxWidth: '800px',
      data: { packet, profile },
    });
  }
}
